
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/avui-a-cardedeu",
      function () {
        return require("private-next-pages/avui-a-cardedeu.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/avui-a-cardedeu"])
      });
    }
  